/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "Lưu chuyển tiền từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "Thu nhập lãi và các khoản thu nhập tương tự nhận được",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "Chi phí lãi và các chi phí tương tự đã trả (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "Thu nhập từ hoạt động dịch vụ nhận được",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset:
      "Chênh lệch số tiền thực thu/thực chi từ hoạt động kinh doanh (ngoại tệ/vàng bạc, chứng khoán)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "Thu nhập khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "Tiền thu các khoản nợ đã được xử lý xóa, bù đắp bằng nguồn rủi ro",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "Tiền chi trả cho nhân viên và hoạt động quản lý, công vụ (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    asset: "Tiền thuế thu nhập thực nộp trong kỳ (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "",
    asset:
      "Lưu chuyển tiền thuần từ hoạt động kinh doanh trước những thay đổi về tài sản và vốn lưu động",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 10,
    stt: "",
    asset: "Những thay đổi về tài sản hoạt động",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 11,
    stt: "09",
    asset: "(Tăng)/Giảm các khoản tiền, vàng gửi và cho vay các TCTD khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "10",
    asset: "(Tăng)/Giảm các khoản về kinh doanh chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "11",
    asset: "(Tăng)/Giảm các công cụ  tài chính phái sinh và các tài sản tài chính khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "12",
    asset: "(Tăng)/Giảm các khoản cho vay khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "13",
    asset: "Giảm nguồn dự phòng để bù đắp tổn thất các khoản",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "14",
    asset: "(Tăng)/Giảm khác về tài sản hoạt động",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "",
    asset: "Những thay đổi về công nợ hoạt động",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 18,
    stt: "15",
    asset: "Tăng/(Giảm) các khoản nợ chính phủ và NHNN",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "16",
    asset: "Tăng/(Giảm) các khoản tiền gửi, tiền vay các tổ chức tín dụng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "17",
    asset: "Tăng/(Giảm) tiền gửi của khách hàng (bao gồm cả kho bạc Nhà nước)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "18",
    asset:
      "Tăng/(Giảm) phát hành giấy tờ có giá (ngoại trừ giấy tờ có giá phát hành được tính vào hoạt động tài chính)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "19",
    asset: "Tăng/(Giảm) vốn tài trợ, ủy thác đầu tư, cho vay mà TCTD chịu rủi ro",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "20",
    asset: "Tăng/(Giảm) các công cụ tài chính phái sinh và các khoản nợ tài chính khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "21",
    asset: "Tăng/(Giảm) khác về công nợ hoạt động",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "22",
    asset: "Chi từ các quỹ của TCTD (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "I",
    asset: "Lưu chuyển tiền thuần từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "",
    asset: "Lưu chuyển tiền từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 28,
    stt: "01",
    asset: "Mua sắm tài sản cố định (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "02",
    asset: "Tiền thu từ thanh lý, nhượng bán TSCĐ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "03",
    asset: "Tiền chi từ thanh lý, nhượng bán TSCĐ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "04",
    asset: "Mua sắm bất động sản đầu tư (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "05",
    asset: "Tiền thu từ bán, thanh lý bất động sản đầu tư",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "06",
    asset: "Tiền chi ra do bán, thanh lý bất động sản đầu tư (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "07",
    asset:
      "Tiền chi đầu tư, góp vốn vào các đơn vị khác (Chi đầu tư mua công ty con, góp vốn liên doanh, liên kết, các khoản đầu tư dài hạn khác) (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "08",
    asset:
      "Tiền chi đầu tư, góp vốn vào các đơn vị khác (Thu bán, thanh lý công ty con, góp vốn liên doanh, liên kết, các khoản đầu tư dài hạn khác) (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "09",
    asset: "Tiền thu cổ tức và lợi nhuận được chia từ các khoản đầu tư, góp vốn dài hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "II",
    asset: "Lưu chuyển tiền thuần từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "",
    asset: "Lưu chuyển tiền từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    assetColSpan: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 39,
    stt: "01",
    asset: "Tăng vốn cổ phần từ góp vốn và/hoặc phát hành cổ phiếu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "02",
    asset:
      "Tiền thu từ phát hành giấy tờ có giá dài hạn có đủ điều kiện tính vào vốn tự có và các khoản vốn vay dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "03",
    asset:
      "Tiền chi thanh toán giấy tờ có giá dài hạn có đủ điều kiện tính vào vốn tự có và các khoản vốn vay dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "04",
    asset: "Cổ tức trả cho cổ đông, lợi nhuận đã chia (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "05",
    asset: "Tiền chi ra mua cổ phiếu ngân quỹ (*)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "06",
    asset: "Tiền thu được do bán cổ phiếu ngân quỹ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 45,
    stt: "III",
    asset: "Lưu chuyển tiền thuần từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 46,
    stt: "IV",
    asset: "Lưu chuyển tiền thuần trong kỳ (IV=(I+II+III))",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 47,
    stt: "V",
    asset: "Tiền và các khoản tương đương tiền tại thời điểm đầu kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 48,
    stt: "VI",
    asset: "Điều chỉnh ảnh hưởng của thay đổi tỷ giá",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 49,
    stt: "VII",
    asset: "Tiền và các khoản tương đương tiền tại thời điểm cuối kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];

function Table3({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tính: triệu đồng VN
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>

            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  {rows.assetColSpan && rows.assetColSpan === true ? (
                    <>
                      <Td
                        colSpan={2}
                        style={{
                          textAlign:
                            rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.assetBold === true ? "bold" : 400,
                        }}
                      >
                        {rows.asset}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.sttBold === true ? "bold" : 400,
                        }}
                      >
                        {rows.stt}
                      </Td>
                      <Td
                        style={{
                          textAlign:
                            rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.assetBold === true ? "bold" : 400,
                        }}
                      >
                        {rows.asset}
                      </Td>
                    </>
                  )}

                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <Footer formData={formData} />
    </Box>
  );
}

export default memo(Table3);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
